import React from 'react';
import { t } from '@lingui/macro';
import styled from 'styled-components';

import Badge from '@decisiv/ui-components/lib/components/Badge';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import { H3 } from '@decisiv/ui-components/lib/components/Typography';
import CalendarExclamation from '@decisiv/iconix/lib/components/Calendar';

import ROUTE_NAMES from 'setup/Routing/routeNames';

import Card from 'components/DashboardCard';

import { loader } from 'graphql.macro';
import { useQuery } from '@apollo/client';

import Loading from 'components/Loading';

import isNull from 'lodash/isNull';
import { useAssignedToMe } from '../../AssignedToMeContext';
import LinkOrLabel from '../LinkOrLabel';

const dashboardPendingApprovalsQuery = loader(
  './dashboardPendingApprovals.graphql',
);

const Paper = styled(Flex).attrs({ padding: 2 })`
  width: 100%;
  box-shadow: 0 1px 4px rgba(37, 38, 46, 0.4);
  border-radius: 2px;
`;

const getCountText = (loading, total) => {
  /* istanbul ignore next -- @preserve */
  if (loading) return '';

  return isNull(total) ? /* istanbul ignore next -- @preserve */ '―' : total;
};

const infoText = t`View the total number of estimates with a repair status of Pending Approval.`;

const pendingApprovalsLink = `${ROUTE_NAMES.service_events}?caseStatuses=Pending Approval`;

export default function PendingApprovalsCard() {
  const { customerIds, buildFilteredPath } = useAssignedToMe();

  const { loading, data: { appointments: { pagination } = {} } = {} } =
    useQuery(dashboardPendingApprovalsQuery, {
      variables: { customerIds },
    });

  const total = pagination?.totalEntries || 0;

  return (
    <Card text={t`Pending Approvals`} infoText={infoText} marginTop={0}>
      {loading && <Loading />}
      {!loading && (
        <Flex flexDirection="row" marginBottom={1}>
          <Paper marginY={1}>
            <Flex alignItems="top">
              <Badge
                variant="square"
                icon={CalendarExclamation}
                color="warning"
              />
            </Flex>
            <Flex flexDirection="column" marginLeft={1}>
              <H3 weight="regular">{getCountText(loading, total)}</H3>

              <LinkOrLabel
                count={total}
                to={buildFilteredPath(pendingApprovalsLink)}
                text={t`Estimates Pending Approval`}
              />
            </Flex>
          </Paper>
        </Flex>
      )}
    </Card>
  );
}
